var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPrintVendor = function SvgPrintVendor(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.041 146H12L35.0612 26H152L129.041 146Z",
    fill: "#E6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129.5H15L14 135.5H131L132 129.5Z",
    fill: "#9FA4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 128.5C8 127.672 8.67157 127 9.5 127H136.5C137.328 127 138 127.672 138 128.5C138 129.328 137.328 130 136.5 130H9.5C8.67157 130 8 129.328 8 128.5Z",
    fill: "#313E48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4004 102.473V20.5274C71.4004 19.1665 72.5004 18 74.0004 18H130.9C132.3 18 133.5 19.0693 133.5 20.5274V102.473C133.5 103.834 132.4 105 130.9 105H74.0004C72.6004 104.903 71.4004 103.834 71.4004 102.473Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0004 19.5C73.3265 19.5 72.9004 19.9973 72.9004 20.5274V102.473C72.9004 102.874 73.3 103.428 74.0605 103.5H130.9C131.574 103.5 132 103.003 132 102.473V20.5274C132 19.9744 131.551 19.5 130.9 19.5H74.0004ZM69.9004 20.5274C69.9004 18.3357 71.6743 16.5 74.0004 16.5H130.9C133.05 16.5 135 18.1642 135 20.5274V102.473C135 104.664 133.226 106.5 130.9 106.5H73.9484L73.8965 106.496C71.8854 106.357 69.9004 104.786 69.9004 102.473V20.5274Z",
    fill: "#313E48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9004 36.5665C99.9004 35.7381 100.572 35.0665 101.4 35.0665H122.9C123.729 35.0665 124.4 35.7381 124.4 36.5665C124.4 37.3949 123.729 38.0665 122.9 38.0665H101.4C100.572 38.0665 99.9004 37.3949 99.9004 36.5665Z",
    fill: "#313E48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9004 52.1196C99.9004 51.2911 100.572 50.6196 101.4 50.6196H122.9C123.729 50.6196 124.4 51.2911 124.4 52.1196C124.4 52.948 123.729 53.6196 122.9 53.6196H101.4C100.572 53.6196 99.9004 52.948 99.9004 52.1196Z",
    fill: "#313E48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9004 67.381C99.9004 66.5526 100.572 65.881 101.4 65.881H122.9C123.729 65.881 124.4 66.5526 124.4 67.381C124.4 68.2094 123.729 68.881 122.9 68.881H101.4C100.572 68.881 99.9004 68.2094 99.9004 67.381Z",
    fill: "#313E48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9004 82.1564C99.9004 81.328 100.572 80.6564 101.4 80.6564H122.9C123.729 80.6564 124.4 81.328 124.4 82.1564C124.4 82.9849 123.729 83.6564 122.9 83.6564H101.4C100.572 83.6564 99.9004 82.9849 99.9004 82.1564Z",
    fill: "#313E48"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6996 39.4C91.5163 39.4 93.7996 37.1167 93.7996 34.3C93.7996 31.4834 91.5163 29.2 88.6996 29.2C85.883 29.2 83.5996 31.4834 83.5996 34.3C83.5996 37.1167 85.883 39.4 88.6996 39.4Z",
    fill: "#EADB9E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6996 30.7C86.7114 30.7 85.0996 32.3118 85.0996 34.3C85.0996 36.2882 86.7114 37.9 88.6996 37.9C90.6878 37.9 92.2996 36.2882 92.2996 34.3C92.2996 32.3118 90.6878 30.7 88.6996 30.7ZM82.0996 34.3C82.0996 30.6549 85.0545 27.7 88.6996 27.7C92.3447 27.7 95.2996 30.6549 95.2996 34.3C95.2996 37.9451 92.3447 40.9 88.6996 40.9C85.0545 40.9 82.0996 37.9451 82.0996 34.3Z",
    fill: "#313E48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6996 55.1C91.5163 55.1 93.7996 52.8166 93.7996 50C93.7996 47.1833 91.5163 44.9 88.6996 44.9C85.883 44.9 83.5996 47.1833 83.5996 50C83.5996 52.8166 85.883 55.1 88.6996 55.1Z",
    fill: "#94C1AE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6996 46.4C86.7114 46.4 85.0996 48.0118 85.0996 50C85.0996 51.9882 86.7114 53.6 88.6996 53.6C90.6878 53.6 92.2996 51.9882 92.2996 50C92.2996 48.0118 90.6878 46.4 88.6996 46.4ZM82.0996 50C82.0996 46.3549 85.0545 43.4 88.6996 43.4C92.3447 43.4 95.2996 46.3549 95.2996 50C95.2996 53.6451 92.3447 56.6 88.6996 56.6C85.0545 56.6 82.0996 53.6451 82.0996 50Z",
    fill: "#313E48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6996 70.8C91.5163 70.8 93.7996 68.5167 93.7996 65.7C93.7996 62.8834 91.5163 60.6 88.6996 60.6C85.883 60.6 83.5996 62.8834 83.5996 65.7C83.5996 68.5167 85.883 70.8 88.6996 70.8Z",
    fill: "#CFD9E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6996 62.1C86.7114 62.1 85.0996 63.7118 85.0996 65.7C85.0996 67.6882 86.7114 69.3 88.6996 69.3C90.6878 69.3 92.2996 67.6882 92.2996 65.7C92.2996 63.7118 90.6878 62.1 88.6996 62.1ZM82.0996 65.7C82.0996 62.0549 85.0545 59.1 88.6996 59.1C92.3447 59.1 95.2996 62.0549 95.2996 65.7C95.2996 69.3451 92.3447 72.3 88.6996 72.3C85.0545 72.3 82.0996 69.3451 82.0996 65.7Z",
    fill: "#313E48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6 86.2C91.4167 86.2 93.7 83.9167 93.7 81.1C93.7 78.2833 91.4167 76 88.6 76C85.7833 76 83.5 78.2833 83.5 81.1C83.5 83.9167 85.7833 86.2 88.6 86.2Z",
    fill: "#F9AF8D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6 77.5C86.6118 77.5 85 79.1118 85 81.1C85 83.0882 86.6118 84.7 88.6 84.7C90.5882 84.7 92.2 83.0882 92.2 81.1C92.2 79.1118 90.5882 77.5 88.6 77.5ZM82 81.1C82 77.4549 84.9549 74.5 88.6 74.5C92.2451 74.5 95.2 77.4549 95.2 81.1C95.2 84.7451 92.2451 87.7 88.6 87.7C84.9549 87.7 82 84.7451 82 81.1Z",
    fill: "#313E48"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9 129.1H35.1C30.1 129.1 26 125 26 120V98.4C26 93.4 30.1 89.3 35.1 89.3H95.9C100.9 89.3 105 93.4 105 98.4V120C105.1 125.1 101 129.1 95.9 129.1Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1 90.8C30.9284 90.8 27.5 94.2284 27.5 98.4V120C27.5 124.172 30.9284 127.6 35.1 127.6H95.9C100.199 127.6 103.583 124.251 103.5 120.029L103.5 120.015V98.4C103.5 94.2284 100.072 90.8 95.9 90.8H35.1ZM24.5 98.4C24.5 92.5716 29.2716 87.8 35.1 87.8H95.9C101.728 87.8 106.5 92.5716 106.5 98.4V119.986C106.609 125.957 101.796 130.6 95.9 130.6H35.1C29.2716 130.6 24.5 125.828 24.5 120V98.4Z",
    fill: "#313E48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2998 63.8H45.7998V89.3H85.2998V63.8Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2998 62.3H86.7998V90.8H44.2998V62.3ZM47.2998 65.3V87.8H83.7998V65.3H47.2998Z",
    fill: "#313E48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2998 102.3H45.7998V139.5H85.2998V102.3Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2998 100.8H86.7998V141H44.2998V100.8ZM47.2998 103.8V138H83.7998V103.8H47.2998Z",
    fill: "#313E48"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0002 103.8H37.2002V100.8H93.0002V103.8Z",
    fill: "#313E48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6002 114.2H67.7002V111.2H77.6002V114.2Z",
    fill: "#313E48"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6004 122.7H53.4004V119.7H77.6004V122.7Z",
    fill: "#313E48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1004 131.1H53.4004V128.1H61.1004V131.1Z",
    fill: "#313E48"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6 108.7H54.5V114.4H63.6V108.7Z",
    fill: "#EADB9E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 108.7C53 107.872 53.6716 107.2 54.5 107.2H63.6C64.4284 107.2 65.1 107.872 65.1 108.7V114.4C65.1 115.228 64.4284 115.9 63.6 115.9H54.5C53.6716 115.9 53 115.228 53 114.4V108.7ZM56 110.2V112.9H62.1V110.2H56Z",
    fill: "#313E48"
  })));
};
export { SvgPrintVendor as ReactComponent };
export default __webpack_public_path__ + "static/media/print-vendor.1a68f6b1.svg";